// extracted by mini-css-extract-plugin
export default {"container":"PostEditButton-module__container--VfX0j","tooltip":"PostEditButton-module__tooltip--RrvZ3","backlinksPreview":"PostEditButton-module__backlinksPreview--CrKuG"};